export const AddOnId = {
    User: process.env.REACT_APP_ADDON_USER_ID!,
    License: process.env.REACT_APP_ADDON_LICENSE_ID!,
    Organization: process.env.REACT_APP_ADDON_ORGANIZATION_ID!,
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type AddOnId = typeof AddOnId[keyof typeof AddOnId];